// @flow

import type { State } from "@store/reducers";
import type { ManagerSelfServiceSettings } from "@modules/service/reducer/manager-self-service/types";

export const selectManagerSelfServiceSettings = (state: State): ?ManagerSelfServiceSettings =>
  state.service.managerSelfService.settings;
